import { Controller } from "@hotwired/stimulus"
import '@popperjs/core';
import { TempusDominus } from '@eonasdan/tempus-dominus/dist/js/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus';

const timepickerConfig = {
  display: {
    components: {
      decades: false,
      year: false,
      month: false,
      date: false,
      hours: true,
      minutes: true,
      seconds: true,
      useTwentyfourHour: true
    }
  },
  localization: {
    locale: 'es'
  }
}

// Connects to data-controller="timepicker"
export default class extends Controller {
  static values = {
    readonly: Boolean
  }

  connect() {
    const td = new TempusDominus(this.element, timepickerConfig)
    if (this.readonlyValue) td.disable();
  }
}
